import { useQuery } from '@apollo/client/react';
import { isDefined } from 'app-shared/utils';
import { SKIP_ERROR_TOAST_CONTEXT } from '@/apollo/constants/SkipErrorToastContext';
import { GetReferenceDataDocument } from '~/generated/graphql';
export const useReferenceData = () => {
  const { data, loading, error, refetch } = useQuery(GetReferenceDataDocument, {
    context: SKIP_ERROR_TOAST_CONTEXT,
  });
  return {
    collaborators: data?.collaborators ?? [],
    teams: data?.teams ?? [],
    skills: data?.skills ?? [],
    isLoading: loading && !isDefined(data),
    error,
    refetch,
  };
};
